import SearchIcon from '@mui/icons-material/Search';
import { Button, Tooltip, Typography } from '@mui/material';
import KeyboardShortcut from 'app/common/components/keyboard-shortcut';
import type React from 'react';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  color: ${({ theme }) => theme.palette.text.primary};
  align-self: center;
  padding: 0;
  & .MuiButton-label {
    display: flex;
    gap: ${({ theme }) => theme.spacing(0.75)};
  }
`;

const StyledSearchIcon = styled(SearchIcon)`
  margin-right: ${({ theme }) => theme.spacing(1)};
`;

export type SearchButtonProps = {
  readonly onClick: () => void;
};

const SearchButton: React.FC<SearchButtonProps> = (props) => (
  <Tooltip enterDelay={500} title={<KeyboardShortcut keys={['⌘', 'k']} />}>
    <StyledButton onClick={props.onClick} data-testid="header-search-button">
      <StyledSearchIcon />
      <Typography component="div">Search</Typography>
    </StyledButton>
  </Tooltip>
);

export default SearchButton;
